export const LABEL_PANEL_LABELS = {
	TITLE_EDIT: (displayName: string, isCore: boolean): string =>
		isCore ? `Edit core label "${displayName}"` : `Edit custom label "${displayName}"`,
	TITLE_ADD: 'Create label',
	SUBTITLE_CORE_EDIT: 'Update the key display name, description, and label values.',
	SUBTITLE_CUSTOM_EDIT: 'Custom labels appear in dashboards and reports.',
	CANCEL: 'Cancel',
	SAVE: 'Save',
	SAVE_SUCCESS: 'Label saved successfully',
	SAVE_ERROR: 'Something went wrong. Please try again.',
	DELETE_LABEL: 'Delete label',
	DELETE_LABEL_ARIA: (displayName: string): string => `Delete label "${displayName}"`
} as const;
